// schema
// import * as ISchema from '@schema';

// libraries
import * as React from "react";
import { connect } from "react-redux";
import { createFragmentContainer } from "react-relay";

// sudo-trigger-client-update imports
import { IContainer, IProps, IState } from "./SudoTriggerClientUpdate.d";
import { sudoTriggerClientUpdateFragments } from "./SudoTriggerClientUpdate.gql";
import { styles } from "./SudoTriggerClientUpdate.styles";
import { styles as sudoStyles } from "@components/sudo-wrapper/SudoWrapper.styles";
import { sudoTriggerClientUpdate } from "@mutations";

// state
import { IReduxState } from "@reducers/root.reducer";

// util
import { ZonedMoment } from "@util/time-zone.util";
import { snackBarOpen } from "@actions/snack-bar.actions";

// material-ui
import { Button, LinearProgress, Paper } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";

///////////////
// Component //
///////////////
class SudoTriggerClientUpdateCmpt extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      triggerType: "idle",
      loading: false,
    };
  }

  // trigger handler
  private handleTrigger = () => {
    const confirm = window.confirm("Are you sure?");
    if (!confirm) {
      return;
    }

    const force = this.state.triggerType === "force";
    this.setState({ loading: true });
    sudoTriggerClientUpdate(
      this.props.relay.environment,
      { force },
      () => this.onTriggerSuccess(),
      () => this.onTriggerFailure(),
    );
  };

  private onTriggerSuccess() {
    this.setState({ loading: false, triggerType: "idle" });
    this.props.snackBarOpen("Success! Triggered a client update.");
  }

  private onTriggerFailure() {
    this.setState({ loading: false });
    this.props.snackBarOpen("Failed to trigger a client update. ");
  }

  public handleTriggerTypeChange: React.FormEventHandler<any> = (e: any) => {
    this.setState({
      triggerType: e.target.value,
    });
  };

  public render() {
    const { chromeAppUpdateTimes } = this.props.sudo;
    const idleMoment = new ZonedMoment(chromeAppUpdateTimes.idleTime).format(
      "dddd, MM/DD/YYYY @ h:mm:ss a",
    );
    const forceMoment = new ZonedMoment(chromeAppUpdateTimes.forceTime).format(
      "dddd, MM/DD/YYYY @ h:mm:ss a",
    );

    return (
      <Paper elevation={2} style={sudoStyles.paper}>
        <div style={sudoStyles.title}>Trigger Client Update</div>
        <div style={sudoStyles.instructions}>
          This form will cause all chrome users to refetch the latest code.
          <div style={{ paddingTop: 10 }}>Last Idle Update: {idleMoment}</div>
          <div>Last Force Update: {forceMoment}</div>
        </div>
        <div style={sudoStyles.row}>
          <select
            style={sudoStyles.select}
            value={this.state.triggerType}
            onChange={this.handleTriggerTypeChange}
          >
            <option value="idle">Update when idle</option>
            <option value="force">Force immediate update</option>
          </select>
        </div>
        <div style={{ ...sudoStyles.row, flexDirection: "row", alignItems: "center" }}>
          <Button
            variant="contained"
            color="primary"
            style={sudoStyles.btn}
            onClick={() => this.handleTrigger()}
            disabled={this.state.loading}
          >
            Trigger client update
          </Button>
        </div>
        {this.state.loading ? <LinearProgress variant="indeterminate" /> : null}
      </Paper>
    );
  }
}

/////////////////
// With Styles //
/////////////////
export const SudoTriggerClientUpdateStyled = withStyles(styles)(SudoTriggerClientUpdateCmpt);

///////////
// Redux //
///////////
function mapStateToProps(_state: IReduxState, _ownProps: IContainer) {
  return {};
}

const SudoTriggerClientUpdateRedux = connect(mapStateToProps, {
  snackBarOpen,
})(SudoTriggerClientUpdateStyled);

///////////
// Relay //
///////////
export const SudoTriggerClientUpdate = createFragmentContainer<IContainer>(
  SudoTriggerClientUpdateRedux,
  sudoTriggerClientUpdateFragments,
);
